import { render, staticRenderFns } from "./type.vue?vue&type=template&id=03fdfd92&scoped=true&"
import script from "./type.vue?vue&type=script&lang=js&"
export * from "./type.vue?vue&type=script&lang=js&"
import style0 from "./type.vue?vue&type=style&index=0&id=03fdfd92&lang=scss&scoped=true&"
import style1 from "./type.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03fdfd92",
  null
  
)

export default component.exports